import { APP_VERSION, APP_BUILD_DATE } from "@/version";

/**
 * Tiny app version badge in the bottom-left corner.
 * - Desktop: shows "v1.5.0 · 2026-04-28"
 * - Mobile (<sm): compact "v1.5.0" only, almost invisible (50% opacity)
 *
 * Intentionally small and unobtrusive; main purpose is to help with
 * support / debugging ("which version do you see?").
 */
export default function AppVersion() {
  return (
    <div
      className="fixed bottom-1 right-2 z-[1] pointer-events-none select-none font-body text-[9px] sm:text-[10px] text-void/40 sm:text-void/30 tracking-tight"
      data-testid="app-version-badge"
      aria-hidden="true"
    >
      <span className="sm:hidden">v{APP_VERSION}</span>
      <span className="hidden sm:inline">
        v{APP_VERSION} · {APP_BUILD_DATE}
      </span>
    </div>
  );
}
